import { bindActionCreators, combineReducers } from "redux";
import withInputStateFactory from "../../helpers/reducers/input";
import withConstantStateFactory from "../../helpers/reducers/constant";
import withReactiveStateFactory from "../../helpers/reducers/reactive";
import { callback, noop, isPlainObject, isString, withProperties, constant, isFunction } from "../../../utils";

export default function __factory__(options) {
  const { NAME, constants, inputs, mutables } = (
    options = isPlainObject(options) ? options : {}
  );

  const $back = callback(options.back);
  const $code = callback(options.code);
  const $next = callback(options.next);
  const $switch = callback(options.switch);

  function view() {
    let $updater = noop;
    let $focusin = noop;
    let $focusout = noop;
    let $inputUnsubscribe = noop;
    let $logCompleted = constant(true);

    const $this = this;
    const $view = Object.create(null);

    function back(...args) {
      return () => ($view.ACTIVE && $logCompleted() && $back.call($this, ...args))
    }

    function code(...args) {
      return () => ($view.ACTIVE && $logCompleted() && $code.call($this, ...args))
    }

    function next(...args) {
      return () => ($view.ACTIVE && $logCompleted() && $next.call($this, ...args))
    }

    function update(...args) {
      return () => ($view.ACTIVE && $updater.call($this, ...args))
    }

    function focusin(...args) {
      return () => ($view.ACTIVE && $focusin.call($this, ...args))
    }

    function focusout(...args) {
      return () => ($view.ACTIVE && $focusout.call($this, ...args))
    }

    function _switch(...args) {
      return () => ($view.ACTIVE && $logCompleted() && $switch.call($this, ...args))
    }

    function __setupReducer__() {
      const { $inputs, dispatch } = this;

      let reducers = {};
      let inputFields = isPlainObject($inputs) ? Object.keys($inputs) : [];

      inputFields = [].concat(inputs).filter(field => {
        if (isString(field)) {
          const [ inputField ] = field.split('::');
          return inputFields.indexOf(inputField) >= 0;
        }
      });

      const ConstantState = withConstantStateFactory({
        $actions: withProperties(
          Object.create(null),
          bindActionCreators({ back, code, focusin, focusout, next, update, switch: _switch }, dispatch)
        ),

        ...(isPlainObject(constants) ? constants : {})
      });

      const ReactiveState = withReactiveStateFactory.call(this, mutables);

      if (inputFields.length) {
        const InputState = withInputStateFactory.call(this, inputFields);
        reducers = { ...reducers, ...InputState };
        $updater = callback(InputState.$update);
        $focusin = callback(InputState.$focusin);
        $focusout = callback(InputState.$focusout);
        $inputUnsubscribe = callback(InputState.$unsubscribe);
        // $logCompleted = () => InputState.$loggingCompleted;
      }

      $view.Reducer = withProperties(combineReducers({
        ...ConstantState,
        ...ReactiveState,
        ...reducers
      }), {
        teardown() {
          ReactiveState.$unsubscribe();
          $inputUnsubscribe();
          $view.Reducer = null;
        }
      });

      if (isFunction(options.afterSetup)) {
        options.afterSetup.call($this);
      }
    }

    // Reducer is writable and defaults to a no-op function
    withProperties($view, { Reducer: null }, true);

    if (isFunction(options.mount)) {
      withProperties($view, { $mount: options.mount.bind($this) });
    }

    return (view = withProperties($view, { NAME, setup: __setupReducer__.bind($this) }));
  }

  return view;
}
